"use strict";

exports.__esModule = true;
exports.AdvancedDataTableDataProvider = AdvancedDataTableDataProvider;
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _Time = require("../../Time");
var _Timeline = require("../../Timeline");
var _SelectionContext = require("../../Core/SelectionContext");
var _URLFilter = require("../../Core/URLFilter");
var _AdvancedDataSources = require("./AdvancedDataSources");
var _timeline = require("./AdvancedDataSources/timeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var has = require("ramda").has;
var flatten = require("ramda").flatten;
function AdvancedDataTableDataProvider(props) {
  var dataRange = props.dataRange,
    dataSource = props.dataSource,
    children = props.children;
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var selection = _react["default"].useContext(_SelectionContext.SelectionContext);
  var timePeriod = (0, _Time.getTimePeriod)(reportingPeriod, selection, dataRange);
  var urlFilter = _react["default"].useContext(_URLFilter.URLFilterContext);
  var deviceContext = _react["default"].useContext(_Device.DeviceContext);
  var devicesList = _react["default"].useContext(_Device.DeviceListContext);
  var device = (0, _Device.getSelectedDevices)({
    urlFilter: urlFilter,
    deviceContext: deviceContext,
    defaultDeviceList: devicesList,
    selection: selection,
    dataRange: dataRange
  });
  var _React$useContext = _react["default"].useContext(_AdvancedDataSources.AdvancedDataSourceContext),
    loaded = _React$useContext.loaded,
    fetching = _React$useContext.fetching,
    error = _React$useContext.error,
    advDataSource = _React$useContext.data;
  if (error || fetching || !loaded) {
    return children(Object.assign({}, (0, _Timeline.shortCircuitResponse)(), {
      fetching: fetching,
      error: error
    }));
  }
  var body = {
    entity: {
      device: device
    }
  };

  // Using the selection context to construct the query
  if (dataRange === "SELECTION" && selection && selection.selected) {
    var columns = (0, _timeline.getTimelineColumns)(advDataSource.timelineDefinitions, dataSource);

    // For every column, if the column value is present in the selection context, then add it to the query
    if (columns) {
      columns.forEach(function (col) {
        var id = col.id;

        // We only want to update entity.*, dimensions.* and measures.* column names
        var _id$split = id.split("."),
          prefix = _id$split[0],
          field = _id$split[1];
        if (field && has(field, selection.selected)) {
          var _Object$assign;
          var selectedValue = flatten([selection.selected[field]]);
          body[prefix] = Object.assign({}, body[prefix], (_Object$assign = {}, _Object$assign[field] = selectedValue, _Object$assign));
        }
      });
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_Timeline.AdvancedTimelineQueryController, {
    timelineName: dataSource,
    interval: timePeriod.interval,
    body: body
  }, children);
}